/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Screen from '../Screen';
import Button from '../../Button/Button';
import Dialog from '../../Dialog/Dialog';
import Groupview from '../../Groupview/Groupview';
import Service from '../../Util/Service';
import $ from '../../Util/Util';
import './Group.css';

/**
 * Represents the group maintenance screen.
 */

export default class Group extends Screen {

    /**
     * Properties.
     */

    static propTypes = {
        group:                    PropTypes.object,
        users:                    PropTypes.array,
        onBack:                   PropTypes.func.isRequired
    }

    /**
     * Event that fires when the user closes the group maintenance.
     */  

    _onCloseMaintenance = () => {

        // Closing the popup screen

        this.props.onBack();
    }

    /**
     * Event that fires when the user wants to delete the seleced group.
     */

    _onDeleteGroup = () => {
        this.deleteConfirmDialog.open();
    }

    /**
     * Event that fires when the user wants to cancel the deletion of the
     * selected group.
     */

    _cancelDelete = () => {
        this.deleteConfirmDialog.close();
    }

    /**
     * Deletes the selected group.
     */

    _delete = () => {

        // Closing confirm dialog

        this.deleteConfirmDialog.close().then(() => {

            // Showing progress indicator

            this.props.onLoading(true);

            // Deleting the group

            Service.deleteGroup(this.props.group.id).then(() => {

                // Hiding progress indicator

                this.props.onLoading(false);

                // Showing confirm

                $.fireEvent('snackbar', { message: this.props.context.locale.group.deletedmessage });

                // Closing window

                this.props.onBack();
            }).catch((error) => {

                // Hiding progress indicator

                this.props.onLoading(false);

                // Showing error

                $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
            });
        });
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.group.title);

        // Loading the group
        
        this.groupview.load(this.props.group);
    }

    /** 
     * Group maintenance screen renderer.
     */

    render() {
        return (
            <div className="group">

                {/* Group view and maintenance */}

                <Groupview ref={c => {this.groupview = c;}} context={this.props.context} users={this.props.users} onLoading={this.props.onLoading} onClose={this._onCloseMaintenance} onDelete={this._onDeleteGroup} />

                {/* Delete confirm dialog */}

                <Dialog ref={c => {this.deleteConfirmDialog = c;}} width={360} height={104} closetooltip={this.props.context.locale.group.deletedialog.close}>

                    {/* Message */}

                    <div className="group-deletedialog-title">{this.props.context.locale.group.deletedialog.message}</div>
                    <div className="group-deletedialog-groupname">{this.props.group.name}</div>

                    {/* Buttons */}

                    <div className="horizontal">

                        {/* Spacer */}

                        <div className="flex"></div>

                        {/* Delete */}

                        <Button label={this.props.context.locale.group.deletedialog.buttons.yes.label} tooltip={this.props.context.locale.group.deletedialog.buttons.yes.tooltip} width={60} onTouch={this._delete} />

                        {/* Cancel */}

                        <Button label={this.props.context.locale.group.deletedialog.buttons.cancel.label} tooltip={this.props.context.locale.group.deletedialog.buttons.cancel.tooltip} width={60} leftgap={8} onTouch={this._cancelDelete} />
                    </div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Group/Group.js